export class ServiceEntity {
  constructor(u) {
    (this.name = u.name ? u.name : ''),
      (this.code = u.code ? u.code : ''),
      (this.category_id = u.productCategory.id ? u.productCategory.id : ''),
      (this.id = u.id ? u.id : ''),
      (this.amount = u.amount ? u.amount : '');
    this.remarks = u.remarks;
  }
}
